export default __webpack_public_path__ + "static/media/warning.0c3bf9d5.svg";